// extracted by mini-css-extract-plugin
export default {"skill":"Skill_skill__lBFBH","skillItem":"Skill_skillItem__LRJRg","icon":"Skill_icon__1Zkg1","title":"Skill_title__3gH47"};